/*
 * 异步创建script标签
 */
export default function MapLoader() {
  return new Promise((resolve, reject) => {
    if (window.AMap) {
      resolve(window.AMap)
    } else {
      // var url =
      //   'https://webapi.amap.com/maps?v=2.0&key=ef62f98cea8d4028a34ec16dafaaa94a&amp;plugin=AMap.GeoJSON,AMap.Autocomplete,Autocomplete,AMap.PlaceSearch,PlaceSearch,AMap.Geolocation,Geolocation,AMap.Scale,Scale,AMap.OverView,OverView,AMap.ToolBar,ToolBar,AMap.MapType,MapType,AMap.PolyEditor,PolyEditor,AMap.CircleEditor,CircleEditor,AMap.ControlBar,ControlBar,AMap.Weather,Weather,AMap.CitySearch,CitySearch,AMap.Autocomplete,Autocomplete,AMap.PlaceSearch,PlaceSearch,AMap.PolyEditor,PolyEditor,AMap.CircleEditor,CircleEditor&amp;'

      var url =
        'https://webapi.amap.com/maps?v=2.0&key=ef62f98cea8d4028a34ec16dafaaa94a&plugin=AMap.GeoJSON,,AMap.3DTilesLayer'

      _loadJS(url, resolve)
    }
  })
}

function _loadJS(jsFilePath, loadCallback) {
  var _doc = document.getElementsByTagName('head')[0]
  var script = document.createElement('script')
  script.setAttribute('type', 'text/javascript')
  script.setAttribute('src', jsFilePath)
  script.onload = script.onreadystatechange = function () {
    loadCallback && loadCallback()
    script.onload = script.onreadystatechange = null
  }
  _doc.appendChild(script)
}
